import { MissedEntitiesStatus } from '../enums/missed-entities-status-enum';
import * as _ from 'lodash';

export class MissedEntitiesData {
    static getMissedEntitiesStatus(missedEntitiesData): MissedEntitiesStatus {
        return missedEntitiesData
            ? _.defaultTo(missedEntitiesData.missedAbuttingPRsCount, 0) +
                  _.defaultTo(missedEntitiesData.missedAbuttingStreetsCount, 0) +
                  _.defaultTo(missedEntitiesData.missedPRTagsCount, 0) >
              0
                ? MissedEntitiesStatus.HAS_ISSUES
                : MissedEntitiesStatus.NO_ISSUES
            : MissedEntitiesStatus.NOT_DEFINED;
    }
}
